export const emailReg = /^[-+_a-z0-9][-+_.a-z0-9]{0,62}@[a-z0-9][-a-z0-9]{0,62}(\.[a-z0-9][-a-z0-9]{0,62})*\.[a-z]{2,26}$/i;
export const isEMailAddress = ( email: string ): boolean => {

    return email.length >= 6 &&
        email.length < 255 &&
        !email.includes( '..' ) &&
        !email.includes( '.@' ) &&
        emailReg.test( email );

};
